import { useQuery } from "@tanstack/react-query";
import { Module } from "@/constants";
import { ProjectService } from "@/modules/projects/service/project";

export const useProjectQuery = (projectId?: string) => {
  return useQuery({
    queryKey: [Module.Projects, projectId],
    queryFn: () => ProjectService.get(projectId),
    enabled: !!projectId,
  });
};
